import { render, staticRenderFns } from "./GastroPrintBowelCleanseForms.vue?vue&type=template&id=3f0c0265"
import script from "./GastroPrintBowelCleanseForms.vue?vue&type=script&lang=js"
export * from "./GastroPrintBowelCleanseForms.vue?vue&type=script&lang=js"
import style0 from "./GastroPrintBowelCleanseForms.vue?vue&type=style&index=0&id=3f0c0265&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports